import React from 'react';
import "./ads.css"

function Ads() {
  const stamp = Math.floor(Date.now() / 1000);
  console.log(stamp)
  return (
    <div className="ad">
    <div className='ads'><div className="ads1">How To</div><div className="ads2">PLACE TARGETED ADS</div><div className="ads3">on Nairaland</div></div></div>
  )
}

export default Ads